export const AMBASSADOR_FORM_MODAL = 'AMBASSADOR_FORM_MODAL'
export const CONFIRM_MODAL = 'CONFIRM_MODAL'
export const ERRORS_MODAL = 'ERRORS_MODAL'
export const FETCHING_MODAL = 'FETCHING_MODAL'
export const REDEEM_GIFT_MODAL = 'REDEEM_GIFT_MODAL'
export const NEW_CAMPAIGN_FORM_MODAL = 'NEW_CAMPAIGN_FORM_MODAL'
export const EDIT_CAMPAIGN_FORM_MODAL = 'EDIT_CAMPAIGN_FORM_MODAL'
export const ADD_PARTNER_FORM_MODAL = 'ADD_PARTNER_FORM_MODAL'
export const REMOVE_PARTNER_FORM_MODAL = 'REMOVE_PARTNER_FORM_MODAL'
